import { setLoginAccount } from '../../redux/account/action'
import { clearStorage, clearSessionRestore } from '../../utils/storage'
import { logOut } from '../../api/people'

export default (dispatch) => ({
  setLoginAccount: (account) => dispatch(setLoginAccount(account)),
  logOut: (history) => {
    clearSessionRestore()
    clearStorage()
    logOut()
    history.push('/sign-in')
  }
})
